/**
 * Default sets/reps for a freshly-added exercise. A rep range only makes sense
 * for a resistance exercise — cardio, isometric, and stretch exercises are
 * duration-based, so a bare "8-12" reads as meaningless reps instead of a
 * hold/interval time (e.g. Plank shipping with "8-12" reps instead of a
 * duration). Picks the number's unit from the exercise's own `duration_unit`
 * rather than assuming one.
 */
export const getDefaultPrescription = (exercise) => {
  const type = exercise?.exercise_type;
  const unit = exercise?.duration_unit;

  if (type === 'cardio') {
    return { sets: 1, reps: unit === 'seconds' ? '30s' : '10' };
  }
  if (type === 'isometric' || type === 'stretch') {
    return { sets: 3, reps: unit === 'seconds' ? '30s' : '5' };
  }
  return { sets: 3, reps: '8-12' };
};
